// extracted by mini-css-extract-plugin
export var carrierIcon = "_yc-0";
export var carrierLogo = "_yc-1";
export var detailsSection = "_yc-2";